import * as React from 'react';

import { EventFieldOptions, ReportType } from '../api/clients';

import ErrorOverlay from '../../components/ErrorOverlay';
import LoadingOverlay from '../../components/LoadingOverlay';
import useGetEventReportFieldOptions from '../api/hooks/event-report/useGetEventReportFieldOptions';

const CabinEventFieldOptionsContext = React.createContext<EventFieldOptions>(undefined!);

// eslint-disable-next-line max-len
export function CabinEventFieldOptionsProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const cabinEventFieldOptions = useGetEventReportFieldOptions(ReportType.CabinEventReport);

  if (cabinEventFieldOptions.isLoading) {
    return (
      <LoadingOverlay />
    );
  }

  if (cabinEventFieldOptions.status === 'error') {
    return (
      <ErrorOverlay
        title={cabinEventFieldOptions?.error?.title}
        message="An error occurred retrieving data"
      />
    );
  }

  if (cabinEventFieldOptions.data) {
    return (
      <CabinEventFieldOptionsContext.Provider value={cabinEventFieldOptions.data}>
        {children}
      </CabinEventFieldOptionsContext.Provider>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <React.Fragment />;
}

export const useCabinEventFieldOptions = () => React.useContext(CabinEventFieldOptionsContext);
